import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import { Routess } from "../../Routes/routes";
import ErrorImage from "../../assets/img/illustrations/500.svg";


export const ServerError = () => {
  return (
    <main>
      <section className="min-h-screen flex items-center justify-center bg-light">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="lg:w-5/12 text-center lg:text-left order-2 lg:order-1">
              <h1 className="text-primary mt-5 text-4xl lg:text-5xl font-bold">
                Something has gone <span className="font-extrabold">seriously</span> wrong
              </h1>
              <p className="text-gray text-lg my-6 leading-relaxed">
                It's always time for a coffee break. We should be back by the time you finish your coffee.
              </p>
              <Link
                to={Routess.DashboardOverview.path}
                className="inline-flex items-center px-6 py-3 bg-primary text-white font-semibold rounded-lg shadow-lg hover:bg-blue-700 hover:-translate-y-0.5 transition-all text-base"
              >
                <FontAwesomeIcon icon={faChevronLeft} className="mr-2" />
                Go back home
              </Link>
            </div>
            <div className="lg:w-7/12 order-1 lg:order-2 flex justify-center">
              <img src={ErrorImage} className="w-3/4 h-auto max-w-lg" alt="500 Server Error" />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
